<template>
  <div class="af-header is-flex is-align-items-center px-5">
    <router-link v-if="!isLeasing" to="/user/applications" class="logo-router">
      <img
        class="instacash-logo cursor-pointer"
        alt="InstaCash logo"
        :src="require('@/assets/images/instacash-logo-black.svg')"
      />
    </router-link>
    <img
      v-else
      class="instacash-logo"
      :src="getDealerBranding.bigLogo"
      alt="InstaCash logo"
    />

    <div class="ml-auto is-flex is-align-items-center">
      <div class="mr-4 is-hidden-touch" :class="{ 'has-separator': loggedIn }">
        <p class="has-text-grey-3 is-size-7 mb-0">
          {{ $t("af:header.title.call_us") }}
        </p>

        <a
          class="has-text-weight-medium phone-number has-text-grey-dark"
          :href="`tel:${phoneNumber}`"
          >{{ phoneNumber }}</a
        >
      </div>

      <div class="ml-4" v-if="loggedIn">
        <span
          class="user-name-container has-text-weight-medium"
          @click="onProfileClick"
        >
          <b-icon
            icon-pack="fa"
            icon="user-circle"
            size="is-large"
            class="user-profile"
          ></b-icon>
          <span class="todo-badge" v-if="todoCount > 0">
            {{ todoCount }}
          </span>
          <div class="is-hidden-touch user-name">{{ profileName }}</div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import i18n from "@/plugins/i18n";

export default {
  name: "TheHeader",
  methods: {
    onProfileClick() {
      if (this.isLeasing) {
        this.$router.push({
          name: "LeasingProfile",
        });
      } else {
        if (this.todoCount > 0) {
          this.$router.push({
            name: "UserTodos",
          });
        } else {
          this.$router.push({
            name: "Profile",
          });
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      displayName: "session/displayName",
      email: "session/email",
      phone: "session/phone",
      loggedIn: "session/isReady",
      todoCount: "myTodo/getCount",
      getDealerBranding: "leasing/getDealerBranding",
    }),
    isLeasing() {
      return /^\/leasing.*/i.test(this.$route.path);
    },
    profileName() {
      if (!this.displayName) {
        if (!this.email) {
          return this.phone;
        } else {
          return this.email;
        }
      } else {
        return this.displayName;
      }
    },
    phoneNumber() {
      return i18n.t("af:header.title.phone_number");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/colors.scss";

.af-header {
  height: 44px;
  background: white;
  margin: 0;

  .logo-router {
    z-index: 10;
  }

  .phone-number {
    font-size: 14px;
  }

  .user-name-container {
    font-size: 14px;
    cursor: pointer;
    display: flex;
  }

  .user-profile {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    margin-right: 0.5rem;
    margin-top: 0.5rem;
  }

  .user-name {
    margin-top: 1rem;
  }

  .has-separator {
    position: relative;

    &:after {
      content: "";
      position: absolute;
      right: -1rem;
      height: 80%;
      top: 10%;
      width: 1px;
      background: #dfe6ef;
    }
  }

  .todo-badge {
    position: absolute;
    margin-left: 1rem;
    margin-bottom: 3rem;
    height: 1.25rem;
    width: 1.25rem;
    text-align: center;
    background-color: $red;
    border-radius: 16px;
    color: white;
    font-size: 14px;
    padding-top: 0.1rem;
  }

  .instacash-logo {
    height: 40px;
    margin: 0;
    display: block;
  }
}

@media only screen and (min-width: 769px) {
  .af-header {
    height: 60px;
  }
}
</style>
